import { Navigate, useLocation } from "react-router-dom";

import { GlobalUtils } from "../utils/globalUtils";

interface AdminRouteProps {
    element: JSX.Element;
}

export const AdminRoute = ({ element }: AdminRouteProps) => {
    const token = localStorage.getItem("authToken");
    const role = GlobalUtils.getAppRoleFromToken(token);
    const location = useLocation();

  // If no token, redirect to login
    if (!token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

  // If token present but not admin, redirect to profile or unauthorized page
    if (role !== "ADMIN" && role !== "SUPER_ADMIN") {
        return <Navigate to="/profile" replace />;
    }

  // Authorized
    return element;
};